import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	giveFeedback: {
		id: 'polaris-ideas.sidebar.feedback-button.give-feedback',
		defaultMessage: 'Give feedback',
		description: 'It is a label for button that allows users to provide feedback.',
	},
});
